import { MagpieConnection } from 'magpie-lib/connection';
import { getPortalId } from '../../../utils/getPortalId';
import { Logger } from 'simple-logging-lib';
import { UNIFIED_NAVIGATION_UI_LOGGER_NAME } from '../../../constants/logging';
import getWindow from '../../../utils/getWindow';
import { navConfigCache } from '../../../config/cache';
import { navConfigControls } from 'navigation-messaging/messages';
import { navigationPublicApiTopicDef } from 'navigation-messaging/topics';
import { useEffect } from 'react';
import { invalidateNavConfigCache } from '../../../config/getConfig';
import { NavConfigCacheInvalidationError } from '../../../errors/NavConfigCacheInvalidationError';
import { Metrics } from 'foundations-theming/utils/metrics';
import { PUBLIC_API_METHODS, PUBLIC_API_USED } from '../../../constants/metrics';
const replyWithError = (reply, errorMessage) => {
  const replyMessage = navConfigControls.invalidationResponse.create({
    success: false,
    errorMessage
  });
  reply(replyMessage);
};
const replyWithErrorAndLog = (reply, errorMessage) => {
  replyWithError(reply, errorMessage);
  Logger.getLogger(UNIFIED_NAVIGATION_UI_LOGGER_NAME).error(new NavConfigCacheInvalidationError(errorMessage));
};
const replyWithSuccess = reply => {
  const replyMessage = navConfigControls.invalidationResponse.create({
    success: true,
    errorMessage: null
  });
  reply(replyMessage);
};
const handleCacheInvalidationRequest = async (message, reply) => {
  const portalId = getPortalId();
  if (!portalId) {
    replyWithErrorAndLog(reply, 'Portal ID not found');
    return;
  }
  const source = message.payload.source;
  Metrics.counter(PUBLIC_API_USED, {
    action: PUBLIC_API_METHODS.INVALIDATE_NAV_CONFIG
  }).increment();
  const logger = Logger.getLogger(UNIFIED_NAVIGATION_UI_LOGGER_NAME);
  logger.debug('invalidation requested by', source);

  // Remove config from local storage
  navConfigCache.delete();

  // Invalidate nav config on the backend
  const result = await invalidateNavConfigCache(portalId);
  if (result && typeof result === 'object' && 'error' in result) {
    replyWithError(reply, 'Failed to invalidate nav config BE cache');
    return;
  }
  replyWithSuccess(reply);
  if (message.payload.reload === false) {
    return;
  }
  getWindow().location.reload();
};

/**
 * Subscribes to cache invalidation requests from other frontend apps and sends a reply to
 * the requesting app.
 */
const createCacheInvalidationSubscriber = () => {
  return MagpieConnection.get().useTopic(navigationPublicApiTopicDef).on(navConfigControls.requestInvalidation.getType(), (message, {
    reply
  }) => {
    handleCacheInvalidationRequest(message, reply).catch(error => {
      const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
      replyWithError(reply, errorMessage);
    });
  });
};
export const useCacheInvalidationPublicApi = () => {
  useEffect(() => {
    const unsubscribe = createCacheInvalidationSubscriber();
    return () => unsubscribe();
  }, []);
};